import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FileRepository from '@ckeditor/ckeditor5-upload/src/filerepository';
import CkeditorUploadAdapter from '@/Editor/Components/CKEditor/ckeditor-upload.adapter';

export default class CkeditorUploadPlugin extends Plugin {
  static get requires() {
    return [FileRepository];
  }

  async init() {
    const apiUrl = this.editor.config.get('uploadAdapter.apiUrl');
    const beforeUploadCallback = this.editor.config._config.uploadAdapter.beforeUploadCallback;
    const oneTimeTokenQuery = await beforeUploadCallback();
    if (!oneTimeTokenQuery.data) {
      alert('No query for generating OneTimeToken! Image upload disabled.');
      return;
    }
    const { token } = oneTimeTokenQuery.data.generateOneTimeToken;

    this.editor.plugins.get('FileRepository').createUploadAdapter = (fileLoader) => {
      return new CkeditorUploadAdapter(fileLoader, apiUrl, token);
    };
  }
}
